import { render, staticRenderFns } from "./Mission.vue?vue&type=template&id=59da7a04&"
var script = {}
import style0 from "./Mission.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports